var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "order-destination" }, [
    _vm.validCheckoutUser
      ? _c("p", { staticClass: "customer-name" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.getServiceTypeName(_vm.serviceType)) +
              " for " +
              _vm._s(_vm.getCustomerName()) +
              ":\n        "
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    !_vm.validCheckoutUser
      ? _c("p", [
          _c(
            "a",
            {
              attrs: { href: "/sign-in" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.showLogin($event)
                }
              }
            },
            [_vm._v("Please Sign in")]
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", [
      _vm.serviceType === _vm.EServiceType.SERVICE_TYPE_DELIVERY &&
      _vm.deliveryAddress
        ? _c("p", [
            _c("span", { staticClass: "location-name" }, [
              _vm._v("From " + _vm._s(_vm.location.name))
            ]),
            _c("br"),
            _vm._v(" "),
            _vm.hasComponent("streetNumber")
              ? _c("span", [
                  _vm._v(
                    "\n\t\t\t\t\t" +
                      _vm._s(_vm.getStreetNumber()) +
                      " " +
                      _vm._s(_vm.getStreetName()) +
                      " "
                  ),
                  _vm.deliveryAddress.aptNum
                    ? _c("span", [_vm._v(_vm._s(_vm.deliveryAddress.aptNum))])
                    : _vm._e(),
                  _c("br")
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasComponent("locality")
              ? _c("span", [_vm._v(_vm._s(_vm.getLocality()) + ", ")])
              : _vm._e(),
            _vm._v(" "),
            _vm.hasComponent("postalCode")
              ? _c("span", [_vm._v(_vm._s(_vm.getPostalCode()))])
              : _vm._e()
          ])
        : _vm.serviceType === _vm.EServiceType.SERVICE_TYPE_TAKEOUT
          ? _c("p", [
              _c("span", { staticClass: "location-name" }, [
                _vm._v("From " + _vm._s(_vm.location.name))
              ]),
              _c("br"),
              _vm._v(" "),
              _vm.hasComponent("streetNumber")
                ? _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.getStreetNumber()) +
                        " " +
                        _vm._s(_vm.getStreetNumber()) +
                        " " +
                        _vm._s(_vm.formatAptNum(_vm.location)) +
                        ","
                    ),
                    _c("br")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.hasComponent("locality")
                ? _c("span", [
                    _vm._v(
                      "\n\t\t\t\t\t" +
                        _vm._s(_vm.getLocality()) +
                        ", " +
                        _vm._s(_vm.getPostalCode()) +
                        "\n\t\t\t\t"
                    )
                  ])
                : _vm._e()
            ])
          : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-77315d6e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-77315d6e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/checkout/OrderDestination.vue
// module id = null
// module chunks = 